import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"
import BlogArticle from "./blog-article"
import Menu from "../components/menu"

class BlogPostTemplate extends React.Component {
  render() {
    const post = this.props.data.markdownRemark
    const siteTitle = this.props.data.site.siteMetadata.title
    const siteMetadata = this.props.data.site.siteMetadata
    const { previous, next } = this.props.pageContext
    const image = post.frontmatter.image

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <Seo
          title={post.frontmatter.title}
          description={post.frontmatter.description || post.excerpt}
          image={image}
          slug={post.fields.slug}
        />
        <Menu location={this.props.location} />
        <BlogArticle
          node={post}
          idx={0}
          previous={previous}
          next={next}
          siteMetadata={siteMetadata}
        />
      </Layout>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        author
        siteUrl
        social {
          twitter
        }
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      fields {
        slug
      }
      frontmatter {
        title
        date(formatString: "YYYY-MM-DD")
        categories
        image
      }
    }
  }
`
